export const baseURL = ( process.env.REACT_APP_DEPLOYMENT_ENV === 'production' ) ? 
'https://user-api.kureapp.com' : 'https://user-api.dev.kureapp.com';
// 'https://api-data.kureapp.com' : 'https://dev-api-data.kureapp.com';

export const baseChatURL = ( process.env.REACT_APP_DEPLOYMENT_ENV === 'production' ) ?
'https://www.kureapp.com' :
'https://client-dev.kureapp.com';